import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import UserFilter from '../User/Filter/UserFilter';
import UserList from '../User/UserList';

const User = (props) => {
  const initialStateValues = {};

  const [filters, setFilters] = useState(initialStateValues);
  const [postData, setPostData] = useState(null);
  const [resetData, setResetData] = useState(false);

  return (
    <div className="wrapper-fade-in content-min-height mb-5 mt-2">
      <div className="container">
        <UserFilter
          saveFilters={(filters) => setFilters(filters)}
          initialValues={filters}
          initialStateValues={initialStateValues}
          savePostData={(postData) => setPostData(postData)}
          setResetData={setResetData}
        />
        <UserList
          postData={postData}
          resetData={resetData}
          setResetData={setResetData}
        />
      </div>
    </div>
  );
};

export default withRouter(User);
